import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { ClaimsFaqResponse } from '../models/claim-faq.model';
import { ClaimFaqService } from '../services/claim-faq.service';
import { ClaimFaqActionTypes, LoadClaimFaqFail, LoadClaimFaqSuccess } from './claim-faq.actions';

export const claimsFaqLoadEffect = createEffect(
  (action$ = inject(Actions), claimsFaqService = inject(ClaimFaqService)) => {
    return action$.pipe(
      ofType(ClaimFaqActionTypes.LOAD_CLAIM_FAQ),
      switchMap(() =>
        claimsFaqService.getClaimsFaq().pipe(
          map((res: ClaimsFaqResponse) => LoadClaimFaqSuccess(res)),
          catchError(error => of(LoadClaimFaqFail(error)))
        )
      )
    );
  },
  { functional: true }
);
